import Vue from "vue";
import Vuex from "vuex";
import API_ADMIN_ACCESS from "../../api/adminAccess";

Vue.use(Vuex);

export const INITIAL_STATE = {};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {},
  mutations: {},
  actions: {
    async getAdminAccess({ getters }) {
      const url = await API_ADMIN_ACCESS.getAdminAccess(
        getters.selectedClient.id
      );
      return url;
    },
  },
};
